<template>
  <div class="Information">
      <div class="mine_title">
        My Referrals
      </div>
      <!-- 内容 -->
      <div class="info">
        <el-table  header-row-class-name="month_header" header-cell-class-name="month_header"
          :data="info" size="medium"
          style="width: 100%" :border="true">
          <el-table-column
            prop="alias"
            label="Full name">
          </el-table-column>
          <el-table-column
            prop="email"
            label="Email">
            <template slot-scope="scope">
              <p>{{scope.row.email? scope.row.email:'-'}}</p>
            </template>
          </el-table-column>
          <el-table-column
            prop="status"
            label="Status">
            <template slot-scope="scope">
              <p>{{scope.row.interview_status_text}}</p>
<!--              <p v-if="scope.row.appointment_id == 0">Interviews successful</p>-->
<!--              <p v-if="scope.row.appointment_id == 1">Interview didn't pass</p>-->
<!--              <p v-if="scope.row.appointment_id == 2">Waiting for the interview</p>-->
<!--              <p v-if="scope.row.appointment_id == 3">test</p>-->
            </template>
          </el-table-column>
          <el-table-column
            prop="created_at"
            label="Registration time">
          </el-table-column>
        </el-table>
      </div>
  </div>
</template>
<script>
export default {
  components: {

  },
  data() {
    return {
      //菜单列表
      info:[],
    };
  },
  mounted(){
    this.getList()
  },
  methods:{
    getList(){
      this.$http.get('/tutor/api/invitees').then(res => {
        if(res.data.code == 200){
          this.info = res.data.data
        } else {
            this.$message({
              message: res.data.msg,
              type: "warning",
            });
          }
      }).catch(error => {
        console.log(error);
      })
    }
  }
};
</script>
<style lang="less" scoped>
.Information{
  background: #fff;
  padding: 0 24px;
  .mine_title{
      font-family: Roboto;
      font-size: 24px;
      font-weight: 600;
      font-feature-settings: "kern" on;
  }
  .info{
    margin-top: 30px;

  }
}
/deep/.month_header{
    background: #F9FAFB !important;
    height: 50px !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/views/childrens/Inviter.vue